module.exports = __webpack_public_path__ + "media/gaby.505959f8.mp3";